import { call, put, takeLatest } from 'redux-saga/effects'
import api from 'store/api/apiCmo'
import {
  FETCH_EXAM_RESULT,
  FETCH_EXAM_RESULT_SUCCESS,
  FETCH_EXAM_RESULT_FAILURE,
  SAVE_EXAM_RESULT,
  SAVE_EXAM_RESULT_SUCCESS,
  SAVE_EXAM_RESULT_FAILURE,
  DELETE_EXAM_RESULT,
  DELETE_EXAM_RESULT_SUCCESS,
  DELETE_EXAM_RESULT_FAILURE,
} from './actionTypes'

function* fetchResultSaga(action) {
  const { examId, userId } = action.payload
  try {
    const response = yield call(api.get, `/exam/${examId}/result`, { params: { userId } })
    yield put({ type: FETCH_EXAM_RESULT_SUCCESS, payload: { result: response.data.result } })
  } catch (e) {
    yield put({ type: FETCH_EXAM_RESULT_FAILURE, payload: { error: e.message } })
  }
}

function* saveResultSaga(action) {
  const { examId, userId, result } = action.payload
  try {
    const response = yield call(api.post, `/exam/${examId}/result`, { userId, result })
    yield put({ type: SAVE_EXAM_RESULT_SUCCESS, payload: { result: response.data.result } })
  } catch (e) {
    yield put({ type: SAVE_EXAM_RESULT_FAILURE, payload: { error: e.message } })
  }
}

function* deleteResultSaga(action) {
  const { examId, userId } = action.payload
  try {
    yield call(api.delete, `/exam/${examId}/result`, { params: { userId } })
    yield put({ type: DELETE_EXAM_RESULT_SUCCESS })
  } catch (e) {
    yield put({ type: DELETE_EXAM_RESULT_FAILURE, payload: { error: e.message } })
  }
}

export default function* examResultSaga() {
  yield takeLatest(FETCH_EXAM_RESULT, fetchResultSaga)
  yield takeLatest(SAVE_EXAM_RESULT, saveResultSaga)
  yield takeLatest(DELETE_EXAM_RESULT, deleteResultSaga)
}
